<div class="main">
  <div class="header">
      <div>
          <img src="assets/logo_new.svg" alt="Logo">
      </div>
      <div>
          
      </div>
  </div>
  <div class="section">
      <div class="left">
          <div class="content">
              <div class="title_heading">{{'LOGIN.title' | translate}}</div>
              <div class="sub_title">{{'LOGIN.subTitle' | translate}}</div>
          </div>
          <div class="login_form">
              <div class="input_box">
                  <mat-form-field style="width: 92%;">
                      <mat-label class="custom_label">{{'LOGIN.enterEmailAddress' | translate}}</mat-label>
                      <input matInput [(ngModel)]="credentials.email_id">
                    </mat-form-field>
              </div>
              <div class="input_box">
                  <mat-form-field style="width: 92%;">
                      <mat-label class="custom_label">{{'LOGIN.passWord' | translate}}</mat-label>
                      <input matInput [type]="inputType ? 'text' : 'password'" [(ngModel)]="credentials.password" (keyup.enter)="login()">
                      <span class="eye_icon" (click)="togglePasswordVisibility()" *ngIf="!inputType"><img src="assets/close_eye_icon.svg" alt=""></span>
                  <span class="eye_icon" (click)="togglePasswordVisibility()" *ngIf="inputType"><img src="assets/open_eye_icon.svg" alt=""></span>
                    </mat-form-field>
              </div>
              
              <div class="fogot_password" [routerLink]="['/forgot']" routerLinkActive="router-link-active">{{'LOGIN.forgotPasswordButton' | translate}}</div>
          </div>
          <div (click)="login()" class="login_btn">{{'LOGIN.loginButton' | translate}}</div>
          <!-- <div class="remember_checkbox"><mat-checkbox><span class="remember_me">{{'LOGIN.rememberMe' |
                      translate}}</span></mat-checkbox></div> -->
      </div>
      <div class="right">
          <img src="assets/login-page-illustration.svg" alt="">
      </div>
  </div>
</div>